import React, { useEffect, useState } from "react";
import { Grid, Pagination, Box } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { fetchAllProducts } from "../../../State/customer/productSlice";
import ProductCard from "../Product/ProductCard";

const Home = () => {
    const dispatch = useAppDispatch();

    // 🟢 Extracting separate properties directly from your Redux state
    const { products, totalPages } = useAppSelector((state) => state.product);

    // 0-indexed page state to match your Spring Boot backend parameter
    const [page, setPage] = useState(0);
    const itemsPerPage = 30;

    // Fetch products whenever the page index changes
    useEffect(() => {
        dispatch(fetchAllProducts({
            pageNumber: page,
            pageSize: itemsPerPage
        }));
    }, [dispatch, page]);

    const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        // Convert MUI's 1-based index back to Spring's 0-based index
        setPage(value - 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className='space-y-5 lg:space-y-10 relative pb-20'>
            <section className='py-5 px-5 sm:px-10 lg:px-20'>
                <Grid container spacing={1} justifyContent="left">
                    {/* xs: 6  -> 2 columns on extra-small screens (mobile)
      sm: 6  -> 2 columns on small screens (tablet portrait)
      md: 4  -> 3 columns on medium screens (tablet landscape)
      lg: 3  -> 4 columns on large screens (desktop)
    */}
                    {products?.map((product: any) => (
                        <Grid key={product.id} size={{ xs: 6, sm: 6, md: 4, lg: 2 }}>
                            <ProductCard item={product} />
                        </Grid>
                    ))}
                </Grid>

                {/* Pagination Controls */}
                {totalPages > 1 && (
                    <Box className="flex justify-center mt-10">
                        <Pagination
                            count={totalPages}
                            page={page + 1} // MUI uses 1-based indexing
                            onChange={handlePageChange}
                            color="primary"
                            size="large"
                        />
                    </Box>
                )}
            </section>
        </div>
    );
};

export default Home;